import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import TextField from '../../../../../components/TextField';

// Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

// Context
import { useAuth } from '../../../../../context/auth';

//API
import perfil_api from '../../../../../api/perfil_api';
import regional_api from '../../../../../api/regional_api';
import tipoDeFIscalizacao_api from '../../../../../api/tipoDeFIscalizacao_api';
import usuario_api from '../../../../../api/usuario_api';

function Identificacao({ usuario, setUsuario, loadUsuarioItem, editavel }) {

    const { setLoading } = useAuth();

    //State de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //State para pegar os perfil
    const [listaPerfil, setListaPerfil] = useState([]);

    //State para pegar regionais
    const [listaRegionais, setListaRegionais] = useState([]);

    //State para pegar os tipo de fiscalização
    const [listaTipoFiscalizacao, setListaTipoFiscalizacao] = useState([]);

    //Função para pegar lista de perfil
    const loadPerfil = () => {
        setLoading(true);
        perfil_api.getList().then(response => {
            response.data.map(value => {
                value.label = value.identificacao;
                value.value = value.id.toString();
                return value;
            })
            setListaPerfil(response.data)
        })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }

    //Função para pegar lista de regionais
    const loadRegionais = () => {
        setLoading(true);
        regional_api.getList().then(response => {
            response.data.map(value => {
                value.label = value.identificacao;
                value.value = value.id.toString();
                return value;
            })
            setListaRegionais([{ value: 'Todos', label: "Todos" }, ...response.data])
        })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }

    //Função para pegar lista de tipos de fiscalização
    const loadTiposFiscalizacao = () => {
        tipoDeFIscalizacao_api.getList().then(response => {
            response.data.map(value => {
                value.label = value.identificacao;
                value.value = value.id.toString();
                return value;
            })
            setListaTipoFiscalizacao(response.data)
        })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        loadPerfil();
        loadRegionais();
        loadTiposFiscalizacao();
    }, []);

    //Campos obrigatorios
    const camposIdentificacao = [
        objCampo({ name: "nome", required: true }),
        objCampo({ name: "email", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "perfil_Id", required: true })
    ];

    //Função de onChange dos campos
    const onChange = (e) => {
        const { name, value } = e.target;
        const _usuario = {
            ...usuario
        };

        const _campos = camposIdentificacao.filter(campo => campo.name == name);
        const fieldError = validarCampos(_usuario, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setUsuario({
            ...usuario,
            [name]: value
        })
    }

    //Função de onChange dos campos select
    const onChangePerfil = (value, e) => {
        const _usuario = {
            ...usuario,
            usuarioFiscalizacaoEtapas: [],
            [e.name]: value ? value.value : null,
        };

        const _campos = camposIdentificacao.filter(campo => campo.name == e.name);
        const fieldError = validarCampos(_usuario, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });


        setUsuario(_usuario);
    }

    //onChange para os multiSelects
    const onChangeMultiSelect = (e, select) => {
        const { name } = select;
        setUsuario({
            ...usuario,
            [name]: e && e.length > 0 ? e.map(value => value.value) : []
        })
    }

    //onChange para o multiSelect de regionais
    const onChangeMultiSelectRegionais = (e, select) => {
        const { name, option } = select;
        if (option && option.value == "Todos") {
            setUsuario({
                ...usuario,
                [name]: listaRegionais.filter(r => r.value != "Todos").map(r => r.value)
            })
        } else {
            setUsuario({
                ...usuario,
                [name]: e && e.length > 0 ? e.map(value => value.value) : []
            })
        }
    }

    //Função para salvar usuario
    const salveUsuario = () => {
        const _errors = validarCampos(usuario, camposIdentificacao);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _usuario = { ...usuario }

        _usuario.realizaFiscalizacao = _usuario.realizaFiscalizacao == "Sim" ? true : false;

        if (_usuario.id) {
            setLoading(true);
            usuario_api.put(_usuario)
                .then(response => {
                    showMessage("Aviso", "Operação realizada com sucesso", "success", () => loadUsuarioItem());
                })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(() => setLoading(false));
        } else {
            setLoading(true);
            usuario_api.post(_usuario)
                .then(response => {
                    showMessage("Aviso", "Operação realizada com sucesso", "success", () => loadUsuarioItem(response.data));
                })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(() => setLoading(false));
        }
    }

    return <>
        <Row>
            <h5 className='mb-3'>Identificacao do Usuario</h5>
            <Col md="12" lg="4">
                <TextField
                    name={"nome"}
                    label={"* Nome"}
                    value={usuario.nome}
                    invalid={!!errors.nome}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    name={"email"}
                    label={"* Email"}
                    type={"email"}
                    invalid={!!errors.email}
                    value={usuario.email}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    name={"registroFuncional"}
                    label={"Registro Funcional"}
                    type={"text"}
                    invalid={!!errors.registroFuncional}
                    value={usuario.registroFuncional}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    name={"status"}
                    label={"* Status"}
                    type={"select"}
                    value={usuario.status}
                    options={[
                        { label: "Ativo", value: "Ativo" },
                        { label: "Inativo", value: "Inativo" }
                    ]}
                    invalid={!!errors.status}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    name={"perfil_Id"}
                    label={"* Perfil"}
                    type={"select"}
                    searchable
                    options={listaPerfil}
                    invalid={!!errors.perfil_Id}
                    onChange={onChangePerfil}
                    value={listaPerfil.filter(value => value.value == usuario.perfil_Id)}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    name={"realizaFiscalizacao"}
                    label={"* Realizar Fiscalização"}
                    type={"select"}
                    options={[
                        { label: "Sim", value: "Sim" },
                        { label: "Não", value: "Não" }
                    ]}
                    value={usuario.realizaFiscalizacao}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>

            {usuario?.realizaFiscalizacao == "Sim" &&
                <>
                    <TextField
                        name={"regionais"}
                        label={"* Regionais"}
                        multiple
                        type={"select"}
                        value={listaRegionais.filter(r => usuario.regionais.some(x => x == r.id))}
                        options={listaRegionais.filter(r => !usuario.regionais.some(x => x == r.id))}
                        onChange={onChangeMultiSelectRegionais}
                        invalid={!!errors.regionais}
                        disabled={!editavel}
                    />
                    <TextField
                        name={"tipoFiscalizacoes"}
                        label={"* Tipos de fiscalização"}
                        multiple
                        type={"select"}
                        value={listaTipoFiscalizacao.filter(t => usuario.tipoFiscalizacoes.some(x => x == t.id))}
                        options={listaTipoFiscalizacao.filter(t => !usuario.tipoFiscalizacoes.some(x => x == t.id))}
                        onChange={onChangeMultiSelect}
                        invalid={!!errors.tipoFiscalizacoes}
                        disabled={!editavel}
                    />
                </>
            }

            <Row>
                <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                    <Button
                        color={usuario.id ? 'warning text-white' : 'success'}
                        className='px-4'
                        onClick={salveUsuario}>
                        {usuario.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : <><FontAwesomeIcon icon={faSave} /> Salvar</>}
                    </Button>
                </Col>
            </Row>
        </Row>
    </>;
}

export default Identificacao;